export default __webpack_public_path__ + "static/branch04-82043b3313b3d4e42068d42f8c87b1ba.jpg";